import React from 'react';
import Modal, { ModalHeader } from '@xo-union/tk-component-modals';
import { Button } from '@xo-union/tk-component-buttons';

export interface ConfirmationModalProps {
  open: boolean;
  headerText: string;
  bodyText: string;
  cancelText: string;
  confirmText: string;
  onCancel: () => any;
  onConfirm: () => any;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  headerText,
  bodyText,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;
  return (
    <Modal size="sm" onClose={onCancel}>
      <ModalHeader>{headerText}</ModalHeader>
      <div style={{ margin: '30px 0px' }}>{bodyText}</div>
      <Button color="secondary" onClick={onCancel}>
        {cancelText}
      </Button>
      <Button style={{ marginLeft: '10px' }} onClick={onConfirm}>
        {confirmText}
      </Button>
    </Modal>
  );
};
